<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h1 class="calibre15" id="pgepubid00007"><span class="calibre16"> ONE HUNDRED AND THIRD DAY</span><br class="calibre5"/> Tuesday, 9 April 1946</h1>
</div>
<h2 class="nobreak" id="pgepubid00008"><span>Morning Session</span></h2>
<p class="pindent">[<span class="it1">The witness Lammers resumed the stand.</span>]</p>
<p class="pindent">THE PRESIDENT: Yes, Dr. Dix.</p>
<p class="pindent">DR. DIX: Witness, it has been pointed out that I am putting my
question too soon after your answers and that you are replying to
my questions too quickly.</p>
<p class="pindent">MR. JUSTICE ROBERT H. JACKSON (Chief of Counsel for the
United States): I should like to take up a matter before the examination
of the witnesses, if I may ask the indulgence of the Tribunal.</p>
<p class="pindent">I regret to say that this matter of printing documents has proceeded
in its abuses to such an extent that I must close the document
room to printing documents for German counsel. Now, that is
a drastic step, but I know of nothing less that I can do and I submit
the situation to the Tribunal.</p>
<p class="pindent">We received from the General Secretary’s office an order to
print and have printed a Document Book Number I for Rosenberg.
That document book does not contain one item in its 107 pages that,
by any stretch of the imagination, can be relevant to this proceeding.
It is violent anti-Semitism and the United States simply cannot be
put in the position, even at the order—which I have no doubt was
an ill-considered one—of the Secretary of the Tribunal, of printing
and disseminating to the press just plain anti-Semitism; and that is
what this document is. Now, I ask you to consider what it is.</p>
<p class="pindent">I should say it consists of two kinds of things: anti-Semitism and
what I would call, with the greatest respect to those who think
otherwise, rubbish. And this is an example of the rubbish we are
required to print at the expense of the United States and I simply
cannot be silent any longer about this:</p>
<div class="blockquote">
<p class="calibre3">“The philosophic method suited to bourgeois society is the
critical one. That holds true in a positive as well as a negative
sense. The domination of purely rational form, the subjugation
of nature, the freeing of the autonomous personality,
all that is contained in the method of thinking classically
formulated by Kant, likewise, the isolation of the individual,
the inner depletion of nature and community life, the connection
with the world of form which is contained in itself
and with which, all critical thinking is concerned.”</p>
</div>
<p class="pindent"><span id="Page_74" title="74"></span></p>
<p class="pindent">Now, what in the world are we required to print that for?</p>
<p class="pindent">Let us look at some of the anti-Semitism. Now, let us look at
what we are actually asked here to disseminate, Page 47 of this
document book:</p>
<div class="blockquote">
<p class="calibre3">“Actually, the Jews, like the Canaanites in general, like the
Phoenicians and Carthaginians, represent a bastard population...”</p>
</div>
<p class="noindent">And it goes on largely upon that theme. Then it goes on:</p>
<div class="blockquote">
<p class="calibre3">“The Jews are arrogant in success, obsequious in failure,
shrewd and crooked wherever possible, greedy, of remarkable
intelligence, but nevertheless not creative.”</p>
</div>
<p class="pindent">I do not want to take this Tribunal’s time, but last night we
received an additional order to print 260 copies more of this sort of
thing, and I have had to stop the presses; and we cannot accept the
duty of printing this stuff unless it is reviewed by the Tribunal.</p>
<p class="pindent">Most of this book, as far as we have been able to check it, has
already been rejected by the Tribunal; and nobody pays the least
attention to the Tribunal’s rejection, and we are ordered to print.
Now, with the greatest deference, I want to say that the United
States will print any document that a member of this Tribunal or
an alternate certifies, but we can no longer print these things at the
request of the German counsel nor at the ill-considered directions
which we have been receiving.</p>
<p class="pindent">DR. THOMA: At the moment I want merely to explain that on
8 March 1946 I was expressly given permission by the Tribunal to
quote excerpts from philosophical books in my document book.
Consequently, I have based my work on the assumption that Rosenberg’s
ideology is an offspring of the so-called new romantic philosophy
and have quoted philosophical excerpts from serious new
romantic philosophical works, works which have been recognized
by science.</p>
<p class="pindent">Secondly, Your Honors, I have earnestly endeavored not to submit
any anti-Semitic books. What has just been read to me must
be simply translation mistakes.</p>
<p class="pindent">I have quoted the work of a famous Evangelical theological
teacher, Homan-Harling; and secondly, I have quoted a work of a
recognized Jewish scholar, Isma Elbogen; and, thirdly, I have quoted
from an excerpt from the periodical <span class="it1">Kunstschatz</span> written by a Jewish
university professor, Moritz Goldstein. I have deliberately refrained
from bringing anti-Semitic propaganda into this courtroom. I
request, therefore, that the documents quoted by me be investigated
to see whether they are really trash and literary rubbish. I still
maintain that the works which I have quoted were written by
American, English, and French scholars—recognized scholars—and
<span id="Page_75" title="75"></span>
that the quotations which Mr. Justice Jackson has just read about
the bastard race, <span class="it1">et cetera</span>, come as far as I know, from non-German
scholars. But I should have to look at that once more. At any rate,
may I ask the Tribunal that my compilation of excerpts be investigated
to see whether it is in any way nonscientific or not
pertinent.</p>
<p class="pindent">THE PRESIDENT: Mr. Justice Jackson, the Tribunal thinks that
there must have been some mistake in sending to the Translation
Division this book of documents without having it presented to
Counsel for the Prosecution first. The Tribunal made an order some
time ago, saying that Counsel for the Prosecution should have the
right to object to any document before it is sent to the translation
department.</p>
<p class="pindent">Some difficulty then arose because documents had been
mostly in German. There was a difficulty about Counsel for the
Prosecution making up their minds as to their objections until they
have been translated. That difficulty was presented to us a few days
ago; I think you were not in court at the time, but no doubt other
members of the United States counsel were here. We had a full
discussion on the subject, and it was then agreed that Counsel for
the Prosecution should see Counsel for the Defense and, as far as
possible, discuss with them and point out to them the documents
which Counsel for the Prosecution thought ought not to be translated,
and, in case of disagreement, it was ordered that the matter
should be referred to the Tribunal. So that so far as the Tribunal
are concerned, they have done everything that they can to lighten
the work of the Translation Division. Of course, insofar as documents
have been presented to the Translation Division for translation,
which the Tribunal had already denied, that must have been
done by mistake because the General Secretary’s office, no doubt,
ought to have refused to hand over to the Translation Division any
document which the Tribunal had already denied. But the general
principles which I have attempted to explain seem to the Tribunal to
be the only principles upon which we can go, in order to lighten the
work of the Translation Division. That is to say, that Counsel for
the Prosecution should meet Counsel for the Defense and point out
to them what documents are so obviously irrelevant that they ought
not to be translated.</p>
<p class="pindent">MR. JUSTICE JACKSON: Well, if Your Honor pleases, I do not
think it is a mistake. It arises from a fundamental difference which
this Tribunal has not, I think, made clear.</p>
<p class="pindent">What the issues here are—counsel says that he thinks he should
try the new romanticism of Rosenberg. We are charging him for
the murder of 4 or 5 million Jews. The question here is one of
ideology. The only purpose in ever referring to the anti-Semitic
<span id="Page_76" title="76"></span>
sentiments is the motive. There is no purpose here in trying the
question of anti-Semitism or the superiority of races, the fundamental
difference in viewpoint. They believe—and, of course, if they
can try this issue with this Tribunal as a sounding board, it forwards
their purpose—they believe in trying that issue.</p>
<p class="pindent">The first thing we get is this book with the order to print it. We
cannot tell when they are going to present something in the document
room. I simply must not become a party to this spirit of anti-Semitism.
The United States cannot do it. And the Tribunal’s directions
to counsel are simply being ignored; that is the difficulty here.</p>
<p class="pindent">THE PRESIDENT: I do not know if you have in mind the order
which we made on 8 March 1946, in these terms:</p>
<div class="blockquote">
<p class="calibre3">“To avoid unnecessary translation, Defense Counsel will indicate
to the Prosecution the exact passages in all documents
which they propose to use, in order that the Prosecution may
have an opportunity to object to irrelevant passages. In the
event of disagreement between the Prosecution and the Defense
as to the relevancy of any particular passage, the Tribunal
will decide what passages are sufficiently relevant to be translated.
Only the cited passages need be translated, unless the
Prosecution require the translation of the entire document.”</p>
</div>
<p class="pindent">Now, of course, if you are objecting to that ruling on principle,
well and good, but the ruling seems to the Tribunal, up to the
present at any rate, to be the best rule that can be laid down, and
we reiterated it after full discussion a very few days ago.</p>
<p class="pindent">MR. JUSTICE JACKSON: I am calling Your Honor’s attention to
the fact that Your Honor’s order is not being observed and that we
are being given these documents to print without any prior notice.
The boys in the pressroom are not lawyers; they are not in the
position to pass on these things. I do not have the personnel; my
personnel, as this Tribunal well know, is reduced very seriously. I
cannot undertake it in the pressroom here after an order comes from
the General Secretary’s office—a review of what can be done.</p>
<p class="pindent">THE PRESIDENT: Well, but did you...</p>
<p class="pindent">MR. JUSTICE JACKSON: The order is not being carried out;
that is the difficulty.</p>
<p class="pindent">THE PRESIDENT: You mean that none of these documents were
submitted to the Counsel for the Prosecution?</p>
<p class="pindent">MR. JUSTICE JACKSON: The documents were not submitted to
Counsel for Prosecution. They came to the pressroom with an order
to print from the General Secretary’s office. That is what I am
arguing, a grievance; one I shall have to remedy. We are in the very
peculiar position, Your Honor, of being asked to be press agents for
<span id="Page_77" title="77"></span>
these defendants. We were ordered to print 260 copies of these
stencils that I have. The United States cannot be acting as press
agents for the distribution of this anti-Semitic literature, which we
have protested long ago was one of the vices of the Nazi regime,
particularly after they have been argued on and have been denied
by the Court. This, it seems to me, is a flagrant case of contempt of
court, to put these documents through after the Tribunal has ruled
on them and ruled out this whole document book of Rosenberg.</p>
<p class="pindent">THE PRESIDENT: Certainly, so far as these documents have
been denied, they ought never to have been submitted to the translation
department. Might not the Tribunal hear from Sir David
Maxwell-Fyfe, because he was here on the previous occasion, the
last occasion that we dealt with this subject?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: May it please Your Lordship, my
understanding of the matter is that the Rosenberg documents had
been processed—that was what we were informed—before our last
discussion of the matter, and I therefore suggested to the Tribunal
that the practical application of the proceeding should begin with
the documents of the Defendant Frank. That is what I said to the
Tribunal.</p>
<p class="pindent">THE PRESIDENT: Then my recollection is that, after we made
this rule of 8 March 1946, Counsel for the Prosecution—I think all
four prosecutors, and I rather think the document came in signed by
the United States, but I am not certain of it—pointed out that there
were great difficulties in carrying out this ruling of 8 March, because
of the difficulty of Counsel for the Prosecution making up their
minds about what documents were irrelevant, having regard to the
fact that they had to be translated for them to do it. Is that not so?</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: That difficulty arose with
Dr. Horn over the Ribbentrop documents.</p>
<p class="pindent">THE PRESIDENT: But a written application was made to the
Tribunal to vary this rule of 8 March 1946, and it was then after
that that we had the subsequent discussion in open court when we
came to the conclusion that we had better adhere to the ruling of
8 March 1946. And I see from Rosenberg that the documents, these
documents, had been processed already beforehand.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: Since our last discussion, of
course, we have been trying to get this procedure going. Dr. Dix has
met Mr. Dodd and me on the Schacht documents, and I understand
that other learned Defense Counsel are making arrangements to
meet various members with regard to theirs. But before this time,
before the matter arose sharply on the Ribbentrop documents, there
had not been any discussion with Counsel for the Prosecution. That
is the position.
<span id="Page_78" title="78"></span></p>
<p class="pindent">THE PRESIDENT: But what I am pointing out is that that was
because the Prosecution were not carrying out the rule of the 8th
March 1946. It may have been impossible to carry it out, but they
were not carrying it out.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I do not know exactly how Your
Lordship means, “The Prosecution were not carrying it out.”</p>
<p class="pindent">THE PRESIDENT: Both the Prosecution and the Defense, I suppose;
because the application which came to us after the ruling of
8 March 1946 was made on behalf of the Prosecution that they had
such difficulties in getting translations for the documents that they
proposed another ruling.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I am sorry, My Lord, if we have
not carried it out. It is the first time that anybody suggested this
to me...</p>
<p class="pindent">THE PRESIDENT: I do not mean to criticize you.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: We all have taken immense
trouble. Everyone co-operated in every way. I was not aware that
we were at fault; I am very sorry if we were.</p>
<p class="pindent">THE PRESIDENT: I do not mean that, Sir David, but I think
there was a difficulty in carrying this out, and I think there was a
proposal that the rule should be varied. I will look into that and see
whether I am right about it. I remember seeing such an application,
and then we had the subsequent discussion in open court in which
we decided to adhere to this rule of 8 March; and no doubt this
difficulty has arisen, as you pointed out, because of the Rosenberg
documents’ having been processed before.</p>
<p class="pindent">Probably the best course would be now...</p>
<p class="pindent">[<span class="it1">There was a pause in the proceedings while the Judges conferred.</span>]</p>
<p class="pindent">Mr. Justice Jackson, wouldn’t the best course be for you to object
in writing to all the documents which you object to, and then they
will be dealt with by the Tribunal after argument.</p>
<p class="pindent">MR. JUSTICE JACKSON: But, Your Honor, the Tribunal has
once rejected the documents, and yet we get an order to print. The
Tribunal’s orders are not being observed, and—I do not want to
criticize counsel—but we have had no opportunity to pass on these.
These stencils that I stopped running last night are not anything
that has been submitted to us. They have no possible place in the
legitimate issues of this Tribunal, and we will get nowhere talking
to Dr. Thoma about it. He thinks their philosophy is an issue.</p>
<p class="pindent">What I think must be done here, if we are going to get this
solved, is that the Tribunal—if I may make a suggestion, which I do
with great deference; I may be a biased judge of what ought to be
done; I never pretended to complete impartiality—that the Tribunal
<span id="Page_79" title="79"></span>
name a master to represent it in passing these things. We won’t
finish this by discussion between Dr. Thoma and anybody I can
name. My suggestion is that an official pass on these documents
before they are translated. If the master finds a doubtful matter he
can refer it back to you. We should not be in the position either of
agreeing or of disagreeing with them in any final sense, of course.
I realize it is too big a burden to put on the Tribunal to pass on
these papers in advance and too big a burden on the United States
to keep printing them. Paper is a scarce commodity today. Over
25,000 sheets have gone into the printing of a book that has been
rejected. I think there is no possible way except that a lawyer with
some idea of relevance and irrelevance represents this Tribunal in
passing on these things in advance, rather than leaving it to counsel.</p>
<p class="pindent">I would not even venture to sit down with Dr. Thoma, because
we start from totally different viewpoints. He wants to justify anti-Semitism.
I think it is not an issue here. It is the murder of Jews,
of human beings, that is an issue here, not whether the Jewish race
is or is not liked by the Germans. We do not care about that. It is
a matter of settling these issues.</p>
<p class="pindent">COLONEL Y. V. POKROVSKY (Deputy Chief Prosecutor for the
U.S.S.R.): With the Tribunal’s permission, I would like to add a few
words to what Mr. Jackson has said.</p>
<p class="pindent">I do not wish to criticize the counsel either, but the Tribunal has
already said that there may possibly be a mistake. And I would like
to draw the attention of the Tribunal to the fact that this mistake
took place too often. I will permit myself to remind you about the
documents in connection with the Versailles Treaty, which were
rejected by the Tribunal in the most decided manner as not relevant;
the Tribunal will remember also that a considerable amount of time
was spent in listening to the reading of the documents presented by
Dr. Stahmer and Dr. Horn. And I would like to remind the Tribunal
about another fact, when another decision of the Tribunal was
violated. Perhaps it was done by mistake; perhaps not. It took place
when one of the documents which was presented by Dr. Seidl was
published in the papers before it was accepted by the Tribunal as
evidence. And it seems to me that it would be very useful if the
Tribunal could, for the purpose of saving time, guarantee more
effectively that the rules set out by the Tribunal should be obeyed,
not only by the Prosecution, who always follow them carefully, but
also by the Defense Counsel.</p>
<p class="pindent">THE PRESIDENT: Yes, Dr. Thoma?</p>
<p class="pindent">DR. THOMA: I am very much disconcerted by the reproach that I
have not followed the instructions of the Tribunal. During discussions
regarding which documents were admissible, I explained in
<span id="Page_80" title="80"></span>
detail just which philosophical works I want to quote from and why.
It has been stated during the case for the Prosecution, that Rosenberg
invented his philosophy for the purpose of aggressive war and
for the committing of war crimes, <span class="it1">et cetera</span>. I considered it my duty
to prove that this so-called national...</p>
<p class="pindent">THE PRESIDENT: Will you tell the Tribunal where the Prosecution
states that he invented his philosophy, whether in the Indictment
or in the presentation?</p>
<p class="pindent">DR. THOMA: I can prove it. It appears in the Churchill speech;
and also in the speech by Justice Jackson there are similar expressions
that Rosenberg’s philosophy had led to that.</p>
<p class="pindent">THE PRESIDENT: You say it appears in Churchill’s speech?</p>
<p class="pindent">DR. THOMA: Yes.</p>
<p class="pindent">THE PRESIDENT: What have we got to do with that? I asked
you whether the Prosecution alleged it in the Indictment or alleged
it in the course of the presentation of the Prosecution, and you
answer me that Mr. Churchill...</p>
<p class="pindent">DR. THOMA: No, it is not Churchill, but rather Mr. Justice Jackson.
In his presentation he said things, the sense of which was about
the same. Consequently I felt that it was my duty to present to the
Tribunal that philosophy which, before Rosenberg, raised similar
arguments and which is indeed the philosophy of the entire world.</p>
<p class="pindent">Regarding the presentation of the document book, the following
happened: The Translation Division asked me to submit my document
book without delay, as they had time at the moment to deal
with it before it was handed to the Tribunal. So the Translation
Division actually received this document earlier than the Tribunal.
But the Tribunal in their resolution of 8 March 1946 had expressly
given me permission to use quotations from these philosophical
works; they refused me only the anti-Semitic works of Goldstein,
Elbogen, and Homan-Harling. Consequently I immediately informed
the Tribunal that documents were contained in my document book
which had not been granted me.</p>
<p class="pindent">And now, Your Honors, something of great importance: I have
just ascertained that the quotation which Mr. Justice Jackson has
just read comes from a French research scholar, Mr. Larouche.</p>
<p class="pindent">Secondly, I have marked with red pencil those passages in my
document book which were to be translated. The passage quoted by
Mr. Justice Jackson was not marked in red and was not meant to be
included in the document book. This is a regrettable error.</p>
<p class="pindent">Thirdly, I should like to refer to the fact—my attention has just
been called to this—that the passage reads literally, “Rosenberg
developed the philosophical technique of the conspiracy and thus
<span id="Page_81" title="81"></span>
created an educational system for an aggressive war.” That was the
expression in Mr. Justice Jackson’s presentation. I therefore felt
justified in pointing out that this entire philosophy was already in
the air and was a philosophical necessity which had to make its
appearance. I therefore believe that I have cleared myself of the
accusation of not having obeyed the ruling of the Tribunal.</p>
<p class="pindent">THE PRESIDENT: Well, Dr. Thoma, were these documents sent
to the pressroom or were they sent to the translation department?</p>
<p class="pindent">DR. THOMA: In my opinion, they were sent to the Translation
Division, since this department had told me that they had time at
the moment, but expected a terrible rush soon. I had my document
ready and I gave it to the Translation Division.</p>
<p class="pindent">THE PRESIDENT: Mr. Justice Jackson stated apparently that
they had been sent to the pressroom and were being disseminated to
the public in that way, but on the outside of each document book
there is this notice that they are not to be publicized until they are
presented before the Tribunal in open court and then only that
portion actually submitted as evidence. Therefore, any documents
which are sent to the translation room are not disseminated, or
ought not to be disseminated to the press and ought not to be publicized
until they are presented before this Tribunal.</p>
<p class="pindent">There seem to be a number of misunderstandings about this
which seem to have arisen principally from the fact that you submitted
your documents to the translation department before they
had been submitted to the Tribunal, and therefore some of them got
translated which were subsequently denied by the Tribunal. Is that
right?</p>
<p class="pindent">DR. THOMA: No, Your Honors, that is not right. First of all, this
was actually a matter of internal procedure in the various offices
of the Translation Division. I gave the Translation Division this
document book because they asked me to do so, and then...</p>
<p class="pindent">THE PRESIDENT: I did not say who had asked whom. I said
that the translation department got the documents for translation.
They received them before they were submitted to the Tribunal,
and, in consequence, they translated certain documents which were
subsequently denied by the Tribunal.</p>
<p class="pindent">DR. THOMA: The only rejected works were, as is known, the
three anti-Semitic works. That these documents from the courtroom
reached the press I naturally did not know. I was merely trying to
lighten the work of the Translation Division. I subsequently informed
the General Secretary that I had submitted the document book and
I referred him to it. The quotations from my philosophical works,
however, were granted to me later. I want to point out again that
I was always of the opinion that this was an entirely internal matter
<span id="Page_82" title="82"></span>
and that these documents could by no means reach the press. I was
not informed about that. I am very well aware that quotations not
read in court are not supposed to reach the press. I have adhered to
that rule. Nothing has as yet been stated in court and therefore it
should not reach the press.</p>
<p class="pindent">THE PRESIDENT: As you no doubt know, the first granting of
documents when they are applied for is expressly provisional, and
afterwards you have to submit your documents in open court, as
Dr. Horn did, and then the Tribunal rules upon their admissibility;
and this other rule was introduced for the purpose of preventing
undue translation. It was decided then that after the Tribunal had
given its provisional ruling as to what was provisionally relevant,
you should then submit the passages you wanted to quote, to the
Prosecution Counsel to give them an opportunity to object, so that
the translation department should not be unduly burdened. That,
as you have explained and as Sir David Maxwell-Fyfe has said, was
not carried out in your case, partly possibly, because, as you say, the
Translation Division was prepared to undertake certain work. Therefore,
documents were submitted to them which the Tribunal subsequently
ruled to be inadmissible.</p>
<p class="pindent">MR. JUSTICE JACKSON: May I correct something which has led
to misunderstanding? I did not mean to say that counsel had sent
the documents to the press in the sense of a newspaper press. They
were sent to the press, the printing press. They were, of course,
printed. The 260 copies we were ordered to print contained the
usual release notice that they were not to be released until used.
They have not reached the press, and I did not mean to say that
they had been sent to the newspaper press; they were sent to our
printing press.</p>
<p class="pindent">THE PRESIDENT: Yes, Dr. Dix?</p>
<p class="pindent">DR. DIX: Your Honors, before a resolution is made to the matter
under discussion, I should like to make just a few remarks, not
referring to the case of Rosenberg but to the Defense in general.
Very serious accusations against the entire Defense have been raised.
The expression was used that the Prosecution was not the press
agent of the Defense. The accusation was raised that the Defense
were trying to make propaganda, and then these accusations reached
their peak in the most serious charge which one can possibly make
in reference to a participant in a trial, that of contempt of Court.</p>
<p class="pindent">In the name of all Defense Counsel I oppose these heavy accusations
with the best and strongest argument possible, that of an
absolutely clean and pure conscience in this respect. Anyone who
has listened to the debate of the last 30 minutes must have recognized
that the differences of opinion, which have cropped up here and on
<span id="Page_83" title="83"></span>
which the Tribunal will now have to announce a decision, are due
again to misunderstandings which have occurred in this courtroom.</p>
<p class="pindent">Mr. Justice Jackson has generously made it clear that he was not
talking about the newspaper press when he said “press,” but about
the printing press. My colleague Dr. Thoma has stated that the only
reason why these documents went to the Translation Division, was
the fact that the Translation Division, very understandingly and
reasonably from their point of view, had said, “We do not have very
much work at the moment. Please let us have it, and we can start
to translate it.” I believe that we could avoid all these difficulties if
we mutually agree that both parties, the Prosecution and the Defense,
are working with good will and loyalty, and that the thought
of deliberately disregarding the rulings of the Tribunal is far from
us. Errors and mistakes can always happen. May I just remind you
that this leakage of news to the press, that some announcements
were released to the press before they were actually the subject of
proceedings here in court, that that was something that happened
quite frequently at the beginning of the Trial. I do not want to
mention examples since the Tribunal knows that it was not the
Defense. I do not know who it was; at any rate it was not the Defense.
But I make no charges. Things like that do happen, and such
an apparatus as this Trial must have a breaking-in period. There
was no ill will at that time either. But I remind you that it was we,
the Defense—I was the spokesman—who quite energetically supported
the ruling that only such matters should reach the press as had
been introduced into the record here in the public sessions, and that
it was after that that the Tribunal passed its ruling. Previously it
had been different.</p>
<p class="pindent">I never considered that an insult, but rather merely the God-given
dependence of human beings. For instance, it was impossible
for me to get the Charter, the basis of our Trial, at the beginning of
the Trial, but eventually it was graciously placed at my disposal by
the press.</p>
<p class="pindent">Thus whenever so complicated an apparatus is set in motion,
there are naturally many errors and mistakes. But we have now
already begun with Sir David to deal with questions of documents
in the most practical manner possible. As long as we had only the
German text, we conferred with the Prosecution in order to find out
what passages the Prosecution believe they can object to. There
were technical difficulties, linguistic difficulties, as long as we had
only the German text and the Prosecutors spoke other languages.
I spoke to the Prosecution, and we realized the problem confronting
the other partners. But that, too, could be solved with good will;
when necessary we used an interpreter. Thus it was an excellent
and a practical method, first, for saving the Translation Division
<span id="Page_84" title="84"></span>
unnecessary work and, secondly, for saving the Tribunal unnecessary
decisions. And it was working beautifully; it had a good start. I
want to claim for the Defense—and I am sure that Sir David will
not contradict me—that this was really our idea as well as the
practice to co-operate in coming to an unofficial agreement beforehand
by conferring with the Prosecution.</p>
<p class="pindent">The Defense in this Trial are in a very difficult position. I think
every one of you will admit that human ability and an almost exceptional
degree of political tact is required in order to defend in this
Trial without ever making some small mistake. At any rate, I, for
myself, do not claim that I am absolutely sure of myself in this
respect or that I will not perhaps commit some small faux pas. We
find ourselves in a very difficult situation, difficult as far as the
world is concerned, difficult as far as the Tribunal are concerned,
and difficult as far as the German public is concerned.</p>
<p class="pindent">May I urge Mr. Justice Jackson to appreciate our difficult task
and not to raise such accusations as those which, unfortunately, we
often have to read in the German press. We cannot always, when
we are attacked in newspaper articles in which unjust accusations
are raised against us, run to the Tribunal and say, “Please help us.”
The Tribunal have more important tasks than that of continuously
protecting the Defense.</p>
<p class="pindent">However, as to the particular accusation that National Socialist
propaganda or that anti-Semitic propaganda is being made here,
I think I can say, with a clear conscience, that none of the Defense
Counsel, no matter what his own philosophy or what his political
views in the past may have been, has ever dreamed of trying to use
this courtroom to make ideological propaganda for the dead—I emphasize
the word “dead”—world of the Third Reich. That would not
only be wrong; it would be worse than a wrong; I might say, using
Talleyrand’s words, that it would be unbearable stupidity to do a
thing like that.</p>
<p class="pindent">But, just because we are being attacked and because we cannot
defend ourselves, and because we cannot decently ask the Tribunal
to protect us against every accusation, I am asking Mr. Justice Jackson
to clear the atmosphere somewhat and to state to us that these
serious accusations—contempt of Court, anti-Semitic propaganda, or
National Socialist propaganda, and so forth—were not really meant
to be raised seriously.</p>
<p class="pindent">I think that the friendly co-operation which has existed between
us and the Prosecution so far—I must openly confess that I look back
to this co-operation with gratitude and that I wholeheartedly acknowledge
the help and comradeship which these gentlemen have
shown me. This should be preserved. Where would it lead us, if we
<span id="Page_85" title="85"></span>
were to oppose each other here like fighting cocks in the cock-pit?
We are all pursuing the same aim.</p>
<p class="pindent">Not only do I ask him to do this but, knowing him as I do, I am
sure that even without my request he will make a statement in
order to clear the atmosphere in regard to this accusation which is
extremely painful not only for the Defense but also for the entire
Court.</p>
<p class="pindent">May I thank you, Your Honor, for being good enough to listen
to me for so long; but I believe that the matter was sufficiently
important to call for further co-operation, without friction and in
the interest of the cause, between the Prosecution and the Defense.</p>
<p class="pindent">DR. THOMA: Your Honors, I ask to be permitted a few words in
order to make a factual correction.</p>
<p class="pindent">I should like to quote exactly in which passage it becomes
apparent that Rosenberg is being held solely responsible for the
mistaken ideology. It says in the presentation of the case for the
American Prosecution, on Page 2254 (Volume V, Page 41) of the
German transcript, that Rosenberg remodeled the German educational
system in order to expose the German people to the will of
the conspirators and to prepare the German nation psychologically
for a war of aggression. That is a quotation which is here at my
disposal.</p>
<p class="pindent">Secondly—one word more, I am forced to reply in person to the
accusation raised by Mr. Justice Jackson—I must state something
which I should normally not have said in this courtroom, namely,
that I have told Herr Rosenberg repeatedly, “Herr Rosenberg, I
cannot defend your anti-Semitism; that, you have to do yourself.”
For that reason I have limited my documents considerably, but have
considered it my duty to place at Rosenberg’s disposal every means
necessary for him to defend himself on this point.</p>
<p class="pindent">I should like to draw your attention once more to the fact that
this passage which has been quoted by Mr. Justice Jackson was not
marked in red in the document book and has been included by error.</p>
<p class="pindent">MR. JUSTICE JACKSON: I certainly do not want to be unfair
to our adversaries; I know they have a very difficult job. However,
I hope the Tribunal has before it—and I shall withdraw all characterizations
and let what I have to say stand on the facts—the order
of 8 March 1946, Paragraph 3 thereof. I call the attention of the
Tribunal to the fact that that reads, “The following documents are
denied as irrelevant: Rosenberg...” And then follows a list of documents:
<span class="it1">Kunstwart</span>, <span class="it1">History of the Jews in Germany</span>, <span class="it1">History of the
Jewish People</span>. Those are the only three that I shall take time to
call to your attention.
<span id="Page_86" title="86"></span></p>
<p class="pindent">Two days after that order Rosenberg’s counsel filed with this
Tribunal, on 10 March 1946, a rather lengthy memorandum in which
he renewed his request for quotations from the books listed.</p>
<p class="pindent">On 23 March 1946, this Tribunal again denied that request as
irrelevant.</p>
<p class="pindent">I will now hand to you the stencils which we were ordered, by
the order of 8 April 1946, to print. They are a little difficult to read.
The first is a quotation from the <span class="it1">History of the Jewish People</span>, one
of the prohibited books. The next is a quotation from <span class="it1">Kunstwart</span>,
another of the prohibited documents. And the third is from the
<span class="it1">History of the Jews in Germany</span>, the third of the books that I have
mentioned.</p>
<p class="pindent">We have not had time to examine all of these stencils, but a
hurried examination of them indicates that they are very largely,
if not entirely, quotations from the prohibited documents.</p>
<p class="pindent">I will make no characterization of it; I simply rest on those facts.</p>
<p class="pindent">THE PRESIDENT: Mr. Justice Jackson, doesn’t the whole point
turn upon the date at which those documents were submitted to the
translation department? Because what Dr. Thoma says is that in
consequence of the translation department’s being ready to accept
documents, he handed them in before they were actually denied by
the Tribunal. And if that is so, it would be obvious, would it not...</p>
<p class="pindent">MR. JUSTICE JACKSON: My Lord, I do not know what he said.
I did not understand that they were handed in before 8 March 1946.
But in any event, even if they were translated, the order to us to
print is dated 8 April 1946 and was delivered with them on 8 April.
Now certainly there was time after the denial to have stopped our
spending of money and effort printing things that had been prohibited,
and which were prohibited twice.</p>
<p class="pindent">I will not characterize it; the facts speak for themselves.</p>
<p class="pindent">THE PRESIDENT: Dr. Thoma, can you help us about the dates
at all? Can you help us as to this? Mr. Justice Jackson has stated
that after these three documents had been refused in the first instance,
you then renewed your request for them on 10 March 1946
and that on 23 March 1946 they were finally denied.</p>
<p class="pindent">Well now, when did you send the documents to the translation
room?</p>
<p class="pindent">DR. THOMA: The documents, I believe, were given to the Translation
Division before 8 March. There was a session regarding the
admissibility of documents; and it was about that time, before a
decision had been made, that the Translation Division had been in
touch with my secretary and asked her to hand in the document
book, since they had heard that it was ready.
<span id="Page_87" title="87"></span></p>
<p class="pindent">I then endeavored in this courtroom to have the philosophy
admitted and had the impression that the Tribunal would not want
to agree to these documents. Thereupon I once more submitted a
written application to the Tribunal in order to have these documents
admitted. When I was then informed that the anti-Semitic books
would not be permitted—and that was a few days after the date of
this decision—I informed the Tribunal that I wanted to draw their
attention to the fact that books which had not been approved were
being translated.</p>
<p class="pindent">THE PRESIDENT: Dr. Thoma, quite naturally, you are not able
to give us the exact dates at this moment, but we will look into this
matter fully.</p>
<p class="pindent">DR. THOMA: I should like once more to draw your attention to
the fact that I myself pointed out that there are excerpts in the
document book which had been refused. I beg you to draw from
that the conclusion that I was not trying to do anything which was
not permissible.</p>
<p class="pindent">THE PRESIDENT: I think, if the document had been denied, the
proper course would have been to withdraw the documents from, or
to communicate with the Translation Division notifying them that
they should be withdrawn.</p>
<p class="pindent">However, the Tribunal thinks that the best course in this matter
would be for the Tribunal to consider Mr. Justice Jackson’s suggestion.
That is, in order to relieve the Prosecution of the task of
deciding or objecting to the documents which are to be submitted to
the translation rooms, that matter should be considered by somebody
deputed by the Tribunal as a master.</p>
<p class="pindent">The Tribunal thinks that Mr. Justice Jackson or the prosecutor’s
committee should apply in writing to strike out all the irrelevant
documents of which they complain in the document book on behalf
of the Defendant Rosenberg, which has been submitted.</p>
<p class="pindent">Third, for the present the Tribunal would adhere to the system
which they have established with the consent of the prosecuting
counsel.</p>
<p class="pindent">The only thing I need add to that is that I find that I was right
in saying that the Court Contact Committee of the Prosecutors did
apply to the Tribunal on 29 March 1946—I have the document before
me—requesting the Tribunal to vary the ruling which they had
made, namely, Ruling 297, made on 8 March 1946.</p>
<p class="pindent">DR. THOMA: I actually visited the officer and told him that the
documents must be taken out, that they must not stay in. However,
it transpired that hundreds of copies had already been bound and
prepared and I was told, “Well, after all, they are not going to be
quoted, so they might as well stay in since they are not going to be
<span id="Page_88" title="88"></span>
quoted.” I expressly made the request to have them taken out of the
document book.</p>
<p class="pindent">THE PRESIDENT: Of course, I did not mean that the Tribunal
were asking the Prosecution to apply in writing to strike out documents
which have already been rejected. Those documents, of course,
will go out without any application; but if and insofar as there are
other documents contained in the Rosenberg document book to
which the Prosecution object, then they might conveniently apply,
although, of course, that matter will have to be discussed in open
court.</p>
<p class="pindent">As I have already pointed out, the granting of any documents is
expressly provided to be provisional, and the application for the
final admission of the documents has to be made in open court.</p>
<p class="pindent">The Tribunal will have a report made to it by the General Secretary
as to these dates and these matters. And now the Tribunal will
adjourn for 10 minutes.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00009">[<span class="it1">A recess was taken.</span>]</h3>
<p class="pindent">THE PRESIDENT: The Tribunal have come to the conclusion
that it will save time if the defendants are called first as the first
witness in the case of each defendant; and, therefore, in the future
the defendant must be called first unless there are some exceptional
reasons, in which case defendant’s counsel may apply to the Tribunal
and the Tribunal will consider those reasons for calling the defendant
in some position later than first witness.</p>
<p class="pindent">Yes, Dr. Dix.</p>
<p class="pindent">DR. DIX: Witness, I had started to say that it had been pointed
out to me that I had asked my questions too quickly after you had
given your answers and that you were answering too quickly after
I had put the question. The interpreters cannot follow, nor can the
stenographers. I ask you, therefore—and I shall do the same—to
pause after each question. I am sure that the Tribunal will not
interpret these pauses as meaning that you are not sure of your
answers.</p>
<p class="pindent">Yesterday you made detailed statements to the Tribunal regarding
the various applications for resignation which Schacht presented
to Hitler and regarding various moves and proposals for peace which
Schacht made or wanted to make, orally or in writing, during the
war to be delivered by you to Hitler. We were speaking about such
a memorandum of the summer of 1941, and I had the feeling that
the Tribunal have procedural objections because I was putting the
contents of the document to the witness and having him confirm
them. The copy of this document is in the strong box which has
<span id="Page_89" title="89"></span>
already been mentioned repeatedly and which was confiscated on
Schacht’s estate by the Red Army when the Red Army marched in.
Despite all efforts the Russian Delegation have not yet succeeded in
getting this strong box.</p>
<p class="pindent">Although some rather good passages are contained therein, I am
perfectly willing to break off here and to put these questions to
Herr Schacht if the Tribunal would prefer that. May I have the
Tribunal’s decision on this question; if necessary I can cease to
discuss the memorandum any further.</p>
<p class="pindent">THE PRESIDENT: The Tribunal had no objection to your asking
this witness about it, but they thought you ought not to put a
leading question and that you ought to ask the witness if he remembers
the document and what the contents of the document were; not
to put to him that it was such and such in the document or some
other passage in the document, but just to ask him what the contents
of the document were.</p>
<p class="pindent">DR. DIX: The dividing line between leading questions and putting
the contents of a document to the witness, a document which the
witness does not remember exactly, is rather fluid. Therefore, I
should prefer to have Herr Schacht give the rest of the contents of
the memorandum; then we would avoid these difficulties. I shall
therefore leave this point and proceed to another field.</p>
<p class="pindent">Witness, you quite correctly stated yesterday in answer to a
question in connection with the defense of Funk by my colleague,
Dr. Sauter, how it was the practice in 1939, that Hitler simply
decreed that the Reichsbank would have to give so much credit. I
want to avoid a mistaken impression on the part of the Tribunal as
to the former position of the Reichsbank in regard to this question.</p>
<p class="pindent">You know that by Hitler’s decree, the Reichsbank in January
1939 lost its former independence. In this decree Hitler ordered
that he would decide what credits the Reichsbank would have to
give; and this restricted decree of Hitler’s was announced and
became effective as a law in June 1939.</p>
<p class="pindent">Therefore, in order that the Tribunal get a proper impression
of the general and also of the former position of the Reichsbank,
I am asking you how the situation was before January 1939, that
is, during Schacht’s term in office as Reichsbank President, which
ended, as is known, in January 1939. Was it possible at that time
for Hitler simply to decree that so much credit was to be given,
or was the Reichsbank still independent and could it refuse such
credit or cancel it?</p>
<p class="pindent">LAMMERS: I do not remember the legal regulations which
existed in this connection to such an extent that I can give a complete
answer as to when and how they were altered. I can confirm
<span id="Page_90" title="90"></span>
one thing, however; that is that during the period when Herr
Schacht was President of the Reichsbank he must have made certain
difficulties for the Führer with reference to the granting of these
credits. I was not present at the discussions between the Führer
and Schacht, but I know from statements made by the Führer that
regarding those credits he met with considerable difficulties and
restraints on Schacht’s part, restraints which finally brought about
Schacht’s resignation from his position as President of the Reichsbank.
On the other hand, I know that at the moment when Funk
became President of the Reichsbank, these difficulties ceased to
exist. These were obviously removed by legal regulations and also
by orders which the Führer had given; for when Funk became
President of the Reichsbank, these credits were simply handled in
the way which I described yesterday, when I described the technical
procedure; in the main orders for credits and Reich loans from the
Reichsbank were merely a simple matter of signature for the Führer.
They were a matter...</p>
<p class="pindent">THE PRESIDENT: I do not think he is able to answer your
question, really. I do not think he is able to answer the question
which you put to him, which was as to the position before 1939,
so I think you must rely upon the decrees and documents.</p>
<p class="pindent">DR. DIX: One moment, Herr Lammers: I shall clarify that right
away. You have just stated how things were handled in practice
in 1939, in the books. Do you not remember that the Reichsbank
had previously been independent as far as the Government was
concerned?</p>
<p class="pindent">LAMMERS: Yes, I do remember. I also recollect that certain
legal alterations were made, but I cannot remember just when.
Without seeing the law books I cannot tell you exactly the contents
of these legal regulations, just what the limitations were in terms of
figures. All I do know is that the position of the President of the
Reichsbank was later reduced considerably according to orders
coming from the Führer.</p>
<p class="pindent">DR. DIX: That is enough. Now, as to the same subject: It is very
difficult even for a German who has lived here the whole time
but particularly for a foreigner, to understand the powerful
machinery of the Third Reich. I think that in spite of the statements
that you made yesterday in answer to the questions which
my colleague, Sauter, put to you, not everything has yet been said
and that you can say still more to inform the Tribunal. If I did
not know what you know, if I were an outsider, then your statements
of yesterday would give me the impression: Well, it was
like this—the Reich Minister of the Interior could not give orders
to the Police; the Reich Minister of Economy did not direct economy
<span id="Page_91" title="91"></span>
independently; all Reich Ministers were without official authority
and could not give instructions as far as the Reich commissioners
for the occupied territories were concerned.</p>
<p class="pindent">MR. DODD: If Your Honors please, I respectfully suggest that
Dr. Dix is really testifying here. I think perhaps he could put his
questions more simply and we can get along faster and get the
answer better.</p>
<p class="pindent">DR. DIX: I shall put my questions more precisely, but I cannot
put that question precisely unless I first of all ascertain, by means
of statements, what has not yet been said up to now. Otherwise the
most precise and shortest question cannot be put, for the Tribunal
would not understand what I am aiming at. I can assure Mr. Dodd,
I shall not ask anything of an uncertain nature; rather I shall put
a very precise question. Let us proceed at once.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] We have already talked about the office
of the Reichsbank President. Now I should like to ask you: If
all these ministers were so hampered in respect to their authority,
who were the men and who were the authorities who could interfere
in departmental jurisdiction and who held the real power?
That is my question. And I might mention that as far as Frank is
concerned, Himmler’s interference has already been mentioned. But
we must go into that question more deeply so that the Tribunal
can see clearly what we are talking about.</p>
<p class="pindent">LAMMERS: The infringement on the authority of the individual
ministers arose because of the number of institutions which the
Führer had created obviously quite consciously as a counterpoise,
I might say, to the various ministers. That is the one faction.
Secondly, it was done through offices created on a higher level,
which, in the interest of a certain uniformity in particular fields,
were to have sole authority. In the last category the typical example
is, in the first instance, the Four Year Plan. In this connection the
Führer desired a comprehensive unified direction which was not
to depend on the wishes of the ministers of the departments, and
consequently, he created the Four Year Plan. In other sectors, in
some way or other, the minister was confronted with a counterpart;
for instance, by the appointment of Herr Ley as Reich Commissioner
for Housing the Minister for Labor lost his jurisdiction in the
important field of housing. He was relieved of one of his main
duties by the appointment of the Plenipotentiary General for the
Allocation of Labor, Herr Sauckel, in the field of labor employment.
As far as economy was concerned, the Minister of Economy, as I
have already mentioned, was considerably limited in his powers
by the setting up of the Four Year Plan and the powers given
to it and later, in addition to that, by the powers which were
transferred to the Minister for Armament and War Production. In
<span id="Page_92" title="92"></span>
the Ministry of the Interior the actual authority of the Chief of
the German Police...</p>
<p class="pindent">THE PRESIDENT: Dr. Dix, the Tribunal thinks that once the
general aspect of the matter has been explained by the witness the
matter can be explained by the defendants themselves from their
particular point of view. I mean the witness is now explaining to
us, and probably indicating he will do it at some length, that with
reference to the Four Year Plan, for instance, there was to be
a unified command which was not to be interfered with by individual
ministers. That explains the general system and when it
comes to the individual defendants they can explain how it applied
to them, and, therefore, we do not want this dealt with at any
great length or in any great detail.</p>
<p class="pindent">DR. DIX: I shall take that into consideration and ask merely a
few more concrete questions.</p>
<p class="pindent">It is not merely a question, Your Lordship, of the ministers
having had to hand over certain fields in their departments to third
persons, but there is also the fact that third persons, because of
their authority, actually interfered in a field which was really under
the jurisdiction of the minister. And now I shall give the witness
a lead: What was, for example, the position of Reichsleiter Bormann?</p>
<p class="pindent">LAMMERS: The Reichsleiter Bormann was a successor to Reich
Minister Hess.</p>
<p class="pindent">DR. DIX: And as far as interference in the ministries is concerned?</p>
<p class="pindent">LAMMERS: He was appointed secretary to the Führer by the
Führer and was thereby directly included in the State sector. As
Chief of the Party Chancellery he was merely the successor to Reich
Minister Hess, who was supposed to represent the wishes and ideas
of the Party. The fact that he was appointed secretary to the
Führer, which meant that in the State sector a considerable number
of things would have to go through Bormann’s hands gained him
a strong position in the State affairs. I had to experience this personally
to a large extent, since I, who originally had at least been
able, on occasion, to report to the Führer alone, could no longer do
that and could get to the Führer only by way of Bormann. Most of
my reports were given in Bormann’s presence and everything which
I formerly had been able to dispatch to the Führer directly, even
pure and simple matters of State, had now to go through the Secretary
of the Führer, through Bormann.</p>
<p class="pindent">DR. DIX: This resulted, of course, in Bormann’s influence in the
various ministries?
<span id="Page_93" title="93"></span></p>
<p class="pindent">LAMMERS: Yes, he had that influence, for all departmental
matters which I could not settle by reporting them to the Führer
directly or by asking for his decision had to be made in writing
and had to go through Bormann. I would then receive word from
Bormann saying this or that is the Führer’s decision. The possibility
of a personal report, which would have enabled me to speak on
behalf of the minister for whom I was reporting, was lacking. They
were not my own affairs; they were always complaints or protests
or differences of opinion among the members of the Cabinet which
I finally could no longer take to the Führer personally.</p>
<p class="pindent">DR. DIX: Thank you, that is enough.</p>
<p class="pindent">And what you say about Bormann, does that not apply to some
extent to the Gauleiter, too, who also interfered in the ministries?</p>
<p class="pindent">LAMMERS: Gauleiter as such, had, of course, to go through the
Party Chancellery; that was the prescribed channel for them. Since
the Gauleiter as a rule, however, were at the same time heads of
Prussian provinces or Reichsstatthalter these two positions were, of
course, somewhat mixed up; and a number of matters, instead of
going through the prescribed channels from the minister concerned
and through me, went directly from the Gauleiter to Reichsleiter
Bormann. There are, in fact, cases where this channel was chosen
deliberately.</p>
<p class="pindent">DR. DIX: Thank you. Regarding the position of Himmler in the
same respect, that of the appointment of a third person with authority,
you made statements yesterday in connection with the cases of
Frank and Frick. Can your statement be extended, in fact, to all
leading ministries, with reference to the increased power given to
Himmler and the SS and his Police?</p>
<p class="pindent">LAMMERS: I did not quite understand the question.</p>
<p class="pindent">DR. DIX: You did not hear the question?</p>
<p class="pindent">LAMMERS: I did not understand the question completely.</p>
<p class="pindent">DR. DIX: Well, under the heading “interference with other
departments” you have talked about Bormann and you have talked
about Gauleiter; yesterday you talked about Himmler, his Police,
and his SS with reference to the cases of Frick and Frank. I am
now asking you whether this increasing power of Himmler’s and
the SS did not similarly affect the other ministries?</p>
<p class="pindent">LAMMERS: To a considerable extent in the most varied fields.</p>
<p class="pindent">DR. DIX: That exhausts that question.</p>
<p class="pindent">I am now coming back to Schacht. We have talked about the
applications for resignation. Now we come to the actual dismissal.
Ministers who were dismissed were usually given a letter of dismissal
by Hitler?
<span id="Page_94" title="94"></span></p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. DIX: And this letter of dismissal, I assume, was drafted by
you and discussed with Hitler?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">DR. DIX: Was considerable attention paid by Hitler to the wording
of this letter of thanks on the occasion of a dismissal?</p>
<p class="pindent">LAMMERS: Hitler usually looked at it carefully and he frequently
made his own improvements, a sharper or a milder wording.</p>
<p class="pindent">DR. DIX: The two letters of dismissal, Your Honors, which concern
Schacht’s dismissal from his office as President of the Reichsbank
and as Minister without Portfolio are included in my document
book as evidence. Therefore I do not propose to put them to the
witness to any extent. There are only two sentences I propose to
quote in the letter of dismissal from Hitler to Schacht on the occasion
of his dismissal from his position as President of the Reichsbank:
“Your name particularly will always be connected with the
first period of national rearmament.” Schacht considered that this
sentence was written deliberately and that it contained a slight
reprimand, a limitation of the praise he was getting. What is your
view to this question, as one concerned in the drafting of that letter
of dismissal?</p>
<p class="pindent">LAMMERS: As far as I can recollect, I drafted the letter in such
a way that a general expression of thanks was made to Schacht.
This additional sentence is due to a personal insertion by the Führer,
as far as I can recollect, because it was not like me to make such
a subtle difference here.</p>
<p class="pindent">DR. DIX: In a later letter of dismissal of 22 January 1943, not
signed by Hitler, but by you by order of the Führer it is said:</p>
<div class="blockquote">
<p class="calibre3">“The Führer, with regard to your general attitude in this
present fateful struggle of the German people, has decided to
relieve you temporarily of your office as Reich Minister.”</p>
</div>
<p class="pindent">Herr Schacht’s feeling regarding his personal safety could not
have been exactly pleasant when he read that sentence.</p>
<p class="pindent">May I ask you, since you drafted this letter on Hitler’s order,
was Schacht’s anxiety unjustified?</p>
<p class="pindent">LAMMERS: As to the reasons which caused the Führer to dismiss
Schacht, I know merely that a letter from Schacht to Reich
Marshal Göring caused the Führer to dismiss Schacht from his
position. The Führer did not inform me of the actual reasons. He
was very violent and ordered me to use this text, implying that he
even wanted it to be somewhat sterner, but I put it in the rather
acceptable form which you find in this letter. The Führer did not
tell me, of course, what further measures were intended against
<span id="Page_95" title="95"></span>
Schacht. But he had expressly ordered me to use the word “temporarily.”</p>
<p class="pindent">DR. DIX: A last question: Originally I had intended to ask you
in detail, as the person best informed on these points, about the slow
development from the year 1933 until Hitler’s complete autocracy.
The answers which you gave to my colleagues yesterday have, in
the main, settled these questions. I do not want to repeat them.
But two questions I should like to have clarified. The Enabling Act
of 1933—that is the law by which the Reichstag deprived itself of
its powers—did this law empower Hitler, the Reich Cabinet, or the
Reich Government?</p>
<p class="pindent">LAMMERS: This Enabling Act gave legislative powers and the
right to alter the Constitution to the Reich Government, and the
Reich Government, in turn, used this power to alter the Constitution,
both expressly as well as by implication, by creating public
law based on usage which...</p>
<p class="pindent">DR. DIX: Yes, thank you. You explained that yesterday. You
do not need to go into that again. Yesterday you pointed out that
this Reich Government consisted not only of National Socialists but
that the majority of their members belonged to other parties. You
mentioned only members of the German National Party, such as
Hugenberg, Dr. Dorpmüller, and Gürtner, and you mentioned the
Stahlhelm, the head of which was Seldte; but you forgot—and that
is why I am asking you—to mention the Center Party. Is it true
that Herr Von Papen came from the Center Party?</p>
<p class="pindent">LAMMERS: Yes, I admit that is correct; but I do not know
whether Herr Von Papen was a member of the Center Party or not.</p>
<p class="pindent">DR. DIX: In my opinion you talk in rather scholarly and
euphemistic terms about public law based on usage. I am going
to give it a different name, but let us not discuss that. All I want
you to tell me is whether during that gradual development toward
complete dictatorship by Hitler, there were some other laws which
were important and, as such, significant?</p>
<p class="pindent">Do you not consider the law after Hindenburg’s death which
unified the offices of the Reich Chancellor and the Reich President
with the result that the incumbent of this office became simultaneously
the supreme military commander to whom the Wehrmacht
swore their oath—do you not consider that law a further milestone
in that development?</p>
<p class="pindent">LAMMERS: That law was one of the most important milestones
in this development, particularly because, by decree of the Reich
Government, it was confirmed by a plebiscite with nearly 100 percent
votes.
<span id="Page_96" title="96"></span></p>
<p class="pindent">DR. DIX: And no further laws were issued to support this development?</p>
<p class="pindent">LAMMERS: No, I do not know of any.</p>
<p class="pindent">DR. DIX: Nor do I.</p>
<p class="pindent">And the other question is whether a combination of terror and
ruse can be called public law based on usage and whether one
should want to call it that. That is a question I do not want to raise
at the moment; I think we are of different opinions in that connection.</p>
<p class="pindent">Your Lordship, I have now finished my questions to the witness
Lammers on behalf of my client. But my colleague Dr. Kubuschok
is away on duty. I do not think the airplane took off yesterday and
therefore I do not think that he can be back. He asked me to
question the witness on behalf of Herr Von Papen, and I wanted
to ask the Tribunal whether I may ask the witness the question
now—there is only one short question—or whether I should wait
until Papen’s defense comes up at the proper time.</p>
<p class="pindent">THE PRESIDENT: No, now, because this witness will not be
called again except for some very exceptional reason.</p>
<p class="pindent">DR. DIX: No, I meant, did you want me to ask the question later
today, when Von Papen’s turn comes in the proper sequence of
defendants?</p>
<p class="pindent">THE PRESIDENT: You may go on now. I think you had better
ask it now.</p>
<p class="pindent">DR. DIX: [<span class="it1">Turning to the witness.</span>] Please call to mind the Röhm
Putsch. Papen’s experiences during that revolt will be discussed
later. But do you remember that Von Papen, who was Vice Chancellor
at the time, demanded his dismissal from Hitler on 3 July
1934, and received this dismissal?</p>
<p class="pindent">LAMMERS: Yes, I cannot tell you whether the date is right, but
it happened right about that time.</p>
<p class="pindent">DR. DIX: Do you also remember whether a short time afterwards,
probably only a few days afterwards, between 7 and 10 July,
you went to see Herr Von Papen by order of Hitler and asked him
whether he was prepared to accept the position of Ambassador to
the Vatican?</p>
<p class="pindent">LAMMERS: I can remember that I visited Von Papen and, acting
on the Führer’s order, was to give him the prospect of another
position and that this concerned a position with the Holy See. But
whether I had been ordered to make him a direct offer, that I cannot
recollect now.</p>
<p class="pindent">DR. DIX: Do you remember what Papen replied to that?
<span id="Page_97" title="97"></span></p>
<p class="pindent">LAMMERS: At that time he was not very much inclined to
accept such a position.</p>
<p class="pindent">DR. DIX: Thank you. I have no further questions.</p>
<p class="pindent">DR. ROBERT SERVATIUS (Counsel for Defendant Sauckel): Witness,
on 21 March 1942 Sauckel was appointed Plenipotentiary for
Allocation of Labor. What were the reasons for Sauckel’s being
chosen for this position?</p>
<p class="pindent">LAMMERS: The Führer was of the opinion that the allocation
of labor had not been pushed with the necessary intensity by the
Reich Minister for Labor and that this task would, therefore, have
to be transferred to a particularly energetic person.</p>
<p class="pindent">DR. SERVATIUS: Did the Führer demand the use of foreign
workers with particular emphasis?</p>
<p class="pindent">LAMMERS: He demanded that all laborers who could possibly
be made available should be used.</p>
<p class="pindent">DR. SERVATIUS: Particularly with reference to foreign laborers?</p>
<p class="pindent">LAMMERS: Yes, foreign countries were also mentioned in that
connection, because at home we had exhausted all possibilities.</p>
<p class="pindent">DR. SERVATIUS: Did you receive the assignment of informing
the highest offices in the occupied territories of the demand that
they do their best to support Sauckel’s task?</p>
<p class="pindent">LAMMERS: That happened very much later. First the appointment
of the Plenipotentiary for Allocation of Labor took place and
was announced to all important offices. I do not think I added any
particular demand to that. But at the beginning of 1944 a conference
took place at the Führer’s headquarters dealing with the program
of labor allocation for the year of 1944. At the end of that
conference, during which Sauckel had been given a number of
injunctions expressed in definite figures, I had the task of writing
to all offices concerned and telling them that they should support
the task Sauckel had just been given, with all the powers at their
disposal.</p>
<p class="pindent">DR. SERVATIUS: You are talking about a meeting at the beginning
of January 1944. An extensive report which you prepared on
that is available. According to this report, Sauckel said during that
meeting that with regard to the number of foreign laborers he would
find it difficult or perhaps even impossible to fulfill the demands
made by the program. What was the reason he gave for that?</p>
<p class="pindent">LAMMERS: The statement is correct, and the reason he gave
was that the executive power necessary for the carrying out of that
task was lacking in the various sectors. He said that if he were to
fulfill his task, then under all circumstances he should not have to
<span id="Page_98" title="98"></span>
rely on a foreign executive power, as, for instance, was the case in
France, but that there must be a German executive power which
supported his actions.</p>
<p class="pindent">DR. SERVATIUS: Did he not talk about the fact that fulfillment
of the demand was impossible because of the danger of the partisans?</p>
<p class="pindent">LAMMERS: He pointed out these difficulties repeatedly, namely,
the partisan danger; and it was regarded as self-evident that no
recruitment of labor could be carried out by him in territories
where the partisans were still fighting.</p>
<p class="pindent">DR. SERVATIUS: Did he demand the pacification of these agitated
partisan territories and demand executive powers in that connection?</p>
<p class="pindent">LAMMERS: Yes, that is correct.</p>
<p class="pindent">DR. SERVATIUS: Did he wish to have the authorities protected
against these resistance movements?</p>
<p class="pindent">LAMMERS: Yes, he wanted the local office to take action, so that
he would have a free hand to work.</p>
<p class="pindent">DR. SERVATIUS: I am quoting one sentence from the report, and
I want you to explain to me how that is to be understood. There
it says:</p>
<div class="blockquote">
<p class="calibre3">“The Reichsleiter of the SS explained that the forces at his
disposal were extremely small, but that he would try by
increasing them and by using them more intensively to win
success for Sauckel’s actions.”</p>
</div>
<p class="pindent">How is that to be understood?</p>
<p class="pindent">LAMMERS: That referred mainly to the Russian territories, in
which there were partisans, and Herr Sauckel thought that he could
not be active there unless these territories were cleared up. Himmler,
who was present, promised to do his best, but he had misgivings
as to whether enough police battalions or other forces would be at
his disposal.</p>
<p class="pindent">DR. SERVATIUS: Then it is right to say that it was a question
of safeguarding the authorities, of safeguarding the territories, and
not a transfer of the recruiting to the SS?</p>
<p class="pindent">LAMMERS: A transfer of this recruiting to the SS, as such, was
not provided. The German executive power demanded by Sauckel
referred in every case to whatever executive power was available.
In France, for instance, it was not the SS but the field command
who had to look after that; and in Russia it was necessary, in part,
for the police battalions to pacify the partisan regions.</p>
<p class="pindent">DR. SERVATIUS: Now, I have a question regarding the Leadership
Corps. A document has been presented here under Number
<span id="Page_99" title="99"></span>
D-720. It bears the signature of Gauleiter Sprenger and has no date,
but it obviously dates from the spring or the beginning of 1945. In
this letter there is mention of a new Reich health law, and it is
supposed to contain a ruling on people suffering from heart and
lung diseases, who are to be eliminated. It says that this law is to
be kept a secret for the time being. On the strength of that law
these families could no longer remain among the public and could
not produce any offspring. Did you know anything about that law?</p>
<p class="pindent">LAMMERS: I did not understand the word. Did you say insane
or what sort of sick people?</p>
<p class="pindent">DR. SERVATIUS: It is a Reich health law referring to people
suffering from heart and lung diseases.</p>
<p class="pindent">LAMMERS: I know nothing whatsoever about that law.</p>
<p class="pindent">DR. SERVATIUS: I did not understand you.</p>
<p class="pindent">LAMMERS: I know nothing about it.</p>
<p class="pindent">DR. SERVATIUS: Would you have had to know about it?</p>
<p class="pindent">LAMMERS: Yes, the Minister of the Interior would have had
to know about it. Health matters were dealt with in his ministry.
It never reached me.</p>
<p class="pindent">DR. SERVATIUS: Thank you. I have no further questions.</p>
<p class="pindent">DR. GUSTAV STEINBAUER (Counsel for Defendant Seyss-Inquart):
Witness, one day after the German troops marched into
Austria a law was published—on 13 March 1938—which has the
heading, “Law for the Reunion of Austria with the German Reich.”
Seyss-Inquart and his Government were surprised by the contents
of this law. I now ask you whether you know the details as to how
this law was decreed in Linz on 13 March 1938.</p>
<p class="pindent">LAMMERS: Like every other radio listener I heard about the
march of German troops into Austria through the radio. And since
I assumed that I might be needed I went to Vienna. At that point
the law had already been signed and published. I did not participate
in the drafting of this law; the Minister of the Interior and
State Secretary Stuckart drafted that law. I did not work on it at
all, because I did not even know that this action was to take place.</p>
<p class="pindent">DR. STEINBAUER: Did these gentlemen you just mentioned tell
you, perhaps, why this law was published so precipitately?</p>
<p class="pindent">LAMMERS: It was the wish of the Führer.</p>
<p class="pindent">DR. STEINBAUER: Thank you. At the same time Dr. Seyss-Inquart
was named an SS Obergruppenführer, not an SS general,
as the Prosecution have stated and in addition the Führer promised
him that within a year he would be made a member of the Reich
<span id="Page_100" title="100"></span>
Government. In 1939 he actually did become Minister without Portfolio.
Did Seyss-Inquart in his capacity as an SS Obergruppenführer
and as Minister without Portfolio carry out any functions of any
kind?</p>
<p class="pindent">LAMMERS: As far as I know, Seyss-Inquart did not become
Obergruppenführer but Gruppenführer. That was merely an honorary
rank which was given him. He had no authority in the SS and
he never served in the SS, as far as I know. He merely wore the
uniform and later he became Obergruppenführer.</p>
<p class="pindent">DR. STEINBAUER: In other words, this was purely an honorary
rank, a matter of uniform, as you correctly say?</p>
<p class="pindent">LAMMERS: Yes, a sort of honorary rank.</p>
<p class="pindent">DR. STEINBAUER: Thank you.</p>
<p class="pindent">One year later Seyss-Inquart was appointed Reich Commissioner
for the Netherlands, and in the Law Gazette for the Netherlands
<span class="it1">Verordnungsblatt</span> as well as in the <span class="it1">Reichsgesetzblatt</span>, this appointment
was published. Do you know whether, apart from this published
decree which appointed him Reichsstatthalter he was also
given a duty within the framework of the Four Year Plan?</p>
<p class="pindent">LAMMERS: From the moment of his appointment as Reich Commissioner
for the Netherlands, Seyss-Inquart experienced the same
limitations of authority as I described yesterday in connection with
Herr Frank and Herr Rosenberg. In other words, certain powers
were held in reserve for the Delegate for the Four Year Plan who
everywhere exercised comprehensive command powers. To this
extent his position was limited from the very beginning.</p>
<p class="pindent">DR. STEINBAUER: What was the position of the German police
in the Netherlands? Was the German police directly under the
command of the Defendant Seyss-Inquart or was it under the
Reichsleiter SS Himmler?</p>
<p class="pindent">LAMMERS: The conditions here are exactly the same, or similar,
as I described them yesterday in connection with the Government
General. The Higher SS and Police Leader was at the disposal of
the Reich commissioner but his technical instructions came from
Himmler.</p>
<p class="pindent">DR. STEINBAUER: Thank you.</p>
<p class="pindent">Do you, Witness, recollect that at the beginning of 1944 you
forwarded to the defendant, in his capacity as Reich Commissioner
for the Netherlands, an order from the Führer according to which
he should draft 250,000 workers in the Netherlands, and that Seyss-Inquart
refused this?</p>
<p class="pindent">LAMMERS: This is the letter which I mentioned previously
when I was being asked questions in connection with Sauckel. It is
<span id="Page_101" title="101"></span>
a circular letter in which everybody was asked to support Sauckel’s
action and individual offices were given orders regarding the numbers
of workers they were to supply. However, I cannot remember
whether the number was 250,000 workers in Seyss-Inquart’s case.
But I do know that Seyss-Inquart told me that he had considerable
misgivings about getting the number ordered of him. He wanted
to take up these misgivings with the Führer.</p>
<p class="pindent">DR. STEINBAUER: Thank you. I have no further questions.</p>
<p class="pindent">DR. HANS LATERNSER (Counsel for the General Staff and High
Command of the German Armed Forces): Witness, did Hitler come
to power in 1933 with the help of the Reichswehr, that is, was there
any military pressure employed at that time?</p>
<p class="pindent">LAMMERS: I myself did not participate directly in the seizure
of power. I cannot tell you, therefore, the exact details. At any
rate, nothing is known to me about the Reichswehr’s having had
any influence on the seizure of power. I assume that if that had
been the case one would have heard about it.</p>
<p class="pindent">DR. LATERNSER: In 1934 there followed co-ordination of the
offices of the head of the State and Reich Chancellor in the person
of Hitler. Could the military leaders have refused to swear the oath
of allegiance to Hitler without violating a law?</p>
<p class="pindent">LAMMERS: The law regarding the head of the State was decreed
constitutionally and thereby the Führer became the Supreme Commander
of the Armed Forces. Any possibility of resisting did not
exist. That would have been pure revolt; it would have been mutiny.</p>
<p class="pindent">DR. LATERNSER: Did you ever hear that military leaders
made proposals regarding the starting or the preparation of an
aggressive war?</p>
<p class="pindent">LAMMERS: No, not in the least.</p>
<p class="pindent">DR. LATERNSER: It is well known that Hitler did not permit
military leaders any influence upon his political decisions. Do you
know of any statements made by Hitler in which he denied the
generals the right to a political judgment?</p>
<p class="pindent">LAMMERS: From the military point of view the Führer praised
the generals as a group and also individual generals very highly.
As far as politics were concerned, he was always of the opinion
that they knew nothing about politics and that one should, as far
as possible, keep them away from a position where political matters
had to be decided.</p>
<p class="pindent">DR. LATERNSER: It is also known that Hitler would not suffer
any contradiction. Was not that the real reason for Blomberg’s dismissal
and the dismissal of Fritsch and Beck—the fact that they
repeatedly contradicted him?
<span id="Page_102" title="102"></span></p>
<p class="pindent">LAMMERS: Yes, I could assume that such personal differences
in the end did bring about the dismissal of Schacht, Blomberg,
Neurath, and Fritsch. But I was never present at such conferences
and I cannot therefore report what was said. But I do think that
they often contradicted the Führer.</p>
<p class="pindent">DR. LATERNSER: Did Hitler distrust the generals, particularly
those of the Army?</p>
<p class="pindent">LAMMERS: One cannot generalize about that. The Führer was
rather reserved in his behavior toward most people. He told each
one only what actually concerned him. If you call that distrust,
then this distrust was present in his relations with almost all ministers
and generals, for nobody was told any more than the Führer
wanted him to hear.</p>
<p class="pindent">DR. LATERNSER: Among the circle of persons who had Hitler’s
complete confidence was there any military leader?</p>
<p class="pindent">LAMMERS: I do not believe so. I do not know of one.</p>
<p class="pindent">DR. LATERNSER: Now one last question: What was the reason
for putting most of the occupied territories under Reich commissioners
and only a few of them under military administration?</p>
<p class="pindent">LAMMERS: As a rule it was the Führer’s wish that occupied
territories be administered by political leaders. He considered generals
unsuited for that task, because he accused them—I might put
it this way—of having no political instinct.</p>
<p class="pindent">DR. LATERNSER: Was it not the plan to replace the military
administration in Belgium by a civilian commissioner even before
1944?</p>
<p class="pindent">LAMMERS: That had long been provided for. Preparations had
already been made, but the Führer could not decide to put it in
force, because he had always been told that in the case of Belgium
there were important military reasons for not establishing a civilian
administration, since Belgium might possibly become again a zone
of combat. So the decision was postponed a year and still longer.</p>
<p class="pindent">DR. LATERNSER: Thank you. I have no further questions.</p>
<p class="pindent">THE PRESIDENT: Do the Prosecution wish to cross-examine?</p>
<p class="pindent">MAJOR F. ELWYN JONES (Junior Counsel for the United Kingdom):
Witness, there is one matter upon which I want to ask you—as
to the powers of Reich ministers under the Constitution of Nazi Germany.
It appears, from your testimony, that they were men with
very little authority, or jurisdiction, or power of command of any
kind, that they were men of straw. Is that so?</p>
<p class="pindent">LAMMERS: Well, to say no authority goes too far. I mean in
respect to politics...
<span id="Page_103" title="103"></span></p>
<p class="pindent">MAJOR JONES: But, they were of an extremely limited character.
That is what you are saying to the Tribunal, isn’t it?</p>
<p class="pindent">LAMMERS: In the main they were administrative chiefs in their
ministries. They were not political ministers who were consulted in
regard to large-scale political matters.</p>
<p class="pindent">MAJOR JONES: Less authority than the ministers of Germany
had under the previous Constitution?</p>
<p class="pindent">LAMMERS: That, beyond doubt, was the case, for under the
former Constitution votes were taken and the minister could at
least give expression to his authority by voting against something
in the Cabinet.</p>
<p class="pindent">MAJOR JONES: I am now going to put to you some observations
which you yourself made in 1938 about the powers of ministers in
the Führer’s State. I am referring to Document 3863-PS. This is
your comment on the Staatsführer in the Third Reich:</p>
<div class="blockquote">
<p class="calibre3">“From this basic total concentration of supreme power in the
person of the Führer there results, however, no excessively
strong and unnecessary centralization of administration in the
hands of the Führer. In my general elaborations on the basic
concept of the Führer State I have already pointed out that
the respect for the authority of the subordinate leader”—Unterführer—“by
those beneath him forbids interference
with every one of his individual orders or measures. This
principle is applied by the Führer in his governmental leadership
in such a manner that, for example, the position of the
Reich ministers is actually a much more independent one than
formerly, even though today the Reich ministers are subordinate
to the Führer’s unlimited power of command, in
respect to their entire official sphere and in respect to every
individual measure and decision on the most trivial matters.
Eagerness to bear responsibility, resolution, energy, coupled
with initiative and real authority, these are the qualities which
the Führer demands above all of his subordinate leaders.
Therefore he allows them the greatest freedom in the execution
of their affairs and in the manner in which they fulfill
their tasks. He is far from exercising petty or even nagging
criticism.”</p>
</div>
<p class="pindent">That is a picture of the power of Reich ministers, which is very
different from the picture you are painting to the Tribunal, is it not?</p>
<p class="pindent">LAMMERS: In my opinion there is not the least contradiction.
All I am saying here is that every minister normally had no say
in respect to large-scale politics. In his own sphere however, he was
the supreme administrative chief. I explained here that as a subordinate
leader he had the widest powers, insofar as the Führer
<span id="Page_104" title="104"></span>
had left him those powers, and that the Führer did not narrow-mindedly
interfere with these powers. He did not think of doing
that. This concerns matters of second- and third-grade importance;
large-scale politics were not discussed here.</p>
<p class="pindent">MAJOR JONES: You see, your picture of the administration of
this vast State of Nazi Germany is a picture of one man deciding
all principal matters himself out of his own intuitive powers. Is
that the picture you seek to present to this Tribunal?</p>
<p class="pindent">LAMMERS: Yes. The Minister was the supreme leader in his
own sphere and insofar as he was not limited, he had greater powers
than any minister previously had had, because the Führer did not
interfere in small matters.</p>
<p class="pindent">MAJOR JONES: In the case of the Defendant Funk, for instance,
you say that he was a small man with no authority, with no influence
upon the decisions of affairs. Is that so?</p>
<p class="pindent">LAMMERS: Regarding the large-scale political issues he had no
authority. But within his department he had considerable influence.
But those were matters of second- or third-grade importance.</p>
<p class="pindent">MAJOR JONES: But decisions, but as to profound important
economic questions like the amount of wealth that was to be extracted
from the occupied territories, the Führer’s decisions were
based upon the representations and recommendations of ministers
like Funk, were they not?</p>
<p class="pindent">LAMMERS: I do not know that. The finance policy in occupied
territories was handled by the Minister for the Eastern Territories
or the Reich commissioners together with the Reich Finance Minister.</p>
<p class="pindent">MAJOR JONES: But as to decisions on economic matters concerned
with the occupied territories, like recommendations as to
occupation costs, as to the technique of purchasing on the black
market, men like Funk had to give recommendations for determination
of policy on these matters, did they not?</p>
<p class="pindent">LAMMERS: He co-operated, yes, but he had no authority as
Reich commissioner in the occupied territories. The Reich commissioner
was directly under Hitler.</p>
<p class="pindent">MAJOR JONES: All these ministers co-operated in their sphere
and were indispensable to the running of this Nazi State, were
they not?</p>
<p class="pindent">LAMMERS: Yes, of course, co-operation was a necessity. This
does not mean that Funk had power to issue orders in the occupied
territories. He certainly had none.</p>
<p class="pindent">MAJOR JONES: You, so far as Funk is concerned, were concerned
with making quite clear what his position was in the State.
Do you recollect that you were concerned with clearing up the
<span id="Page_105" title="105"></span>
matter as to whether he, Funk, was directly subordinate to the
Führer or not? Do you remember that?</p>
<p class="pindent">LAMMERS: Yes, of course Funk, as Minister, was under the
Führer.</p>
<p class="pindent">MAJOR JONES: And he was advising the Führer himself, was
he not?</p>
<p class="pindent">LAMMERS: He very rarely saw the Führer.</p>
<p class="pindent">MAJOR JONES: But, in the vital sphere of the financing of
rearmament, for instance, he had important decisions to communicate
to the Führer and advise the Führer upon, did he not?</p>
<p class="pindent">LAMMERS: I do not know to what extent the Führer sent for
him for I was not present at conferences regarding armament credit
and rearmament.</p>
<p class="pindent">MAJOR JONES: I want to ask you one further question regarding
ministerial matters. Ministers without portfolio did continue to
receive communications as to the Reich Cabinet, did they not?</p>
<p class="pindent">LAMMERS: They received texts of subjects up for discussions.</p>
<p class="pindent">MAJOR JONES: The Defendant Frank, for instance, was a Minister
without Portfolio?</p>
<p class="pindent">LAMMERS: Yes.</p>
<p class="pindent">MAJOR JONES: He continued to receive communications in his
capacity as a Minister without Portfolio?</p>
<p class="pindent">LAMMERS: He received all the texts which were received by
other ministers, provided there was a general distribution.</p>
<p class="pindent">MAJOR JONES: And indeed, when he was the Governor General
of the Government General, he maintained a ministerial office
to deal with the incoming matters of the Reich Cabinet?</p>
<p class="pindent">LAMMERS: Who are you talking about? Frank?</p>
<p class="pindent">MAJOR JONES: I am now talking about the Defendant
Frank, yes.</p>
<p class="pindent">LAMMERS: Frank had an office in Berlin where ministerial
matters were delivered to him.</p>
<p class="pindent">MAJOR JONES: So that the Reich Cabinet did not actually meet,
but it continued to exist, did it not?</p>
<p class="pindent">LAMMERS: The Reich Cabinet existed only for those legislative
and administrative matters which could be handled in writing and
by means of circulating letters.</p>
<p class="pindent">MAJOR JONES: And the members of the Reich Cabinet, like
Frank, continued to receive communications as to the legislative
<span id="Page_106" title="106"></span>
tasks and performances of the Reich Cabinet, even though they
were not available for conferences or meetings?</p>
<p class="pindent">LAMMERS: They got such communications.</p>
<p class="pindent">MAJOR JONES: I think it is time to break off.</p>
<p class="pindent">THE PRESIDENT: Yes.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00010">[<span class="it1">The Tribunal recessed until 1400 hours.</span>]</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?58f3178e